var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#A9CEC1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.4101L5.94144 14L5.00799 9.37342C4.97545 9.21075 5.04411 9.0445 5.18195 8.95219C5.31981 8.85987 5.49968 8.85968 5.63768 8.95169L8.18212 10.648L11.71 7.12013C11.8701 6.95996 12.1298 6.95996 12.29 7.12013L15.8179 10.648L18.3623 8.95169C18.5003 8.85968 18.6802 8.85987 18.818 8.95219C18.9559 9.0445 19.0245 9.21075 18.992 9.37342L18.0586 14L12 14.4101Z",
    fill: "#FFDE66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8181 8.95208C18.6803 8.85976 18.5004 8.8596 18.3624 8.95158L15.8179 10.6479L12.2901 7.12002C12.2094 7.03927 12.1034 6.99935 11.9976 7.00001V14.4099L12.0001 14.41L18.0586 13.9999L18.9921 9.37331C19.0246 9.21064 18.956 9.04439 18.8181 8.95208Z",
    fill: "#FFBD44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94141 15.8828C5.94141 16.1093 6.12505 16.293 6.35156 16.293H11.9975L14.4746 15.1465L12 14H5.94141V15.8828Z",
    fill: "#FFA400"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9976 16.293H17.6485C17.875 16.293 18.0586 16.1093 18.0586 15.8828V14H11.9976V16.293Z",
    fill: "#FD7E3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.9b5d1375ef48f975bf244c885c06311a.svg";
export { ForwardRef as ReactComponent };